import styled from "styled-components";

export const PlayBar = styled.div`
  position: absolute;
  z-index: 1000;
  bottom: 0.7rem;
  left: 0.7rem;
  right: 0.7rem;
  background-color: rgb(255 255 255 / 88%);
  width: 50rem;
  display: flex;
  padding: 0.5rem;
`;
